export const equipmentItems = [
  {
    id: 1,
    name: 'Gosen GM20 EX',
    tagline: 'Stringing Machine 1',
    image: '/images/GM20_EX.jpeg',
  },
  {
    id: 2,
    name: 'Gosen GM25 EX',
    tagline: 'Stringing Machine 2',
    image: '/images/GM25_EX.jpeg',
  },
  {
    id: 3,
    name: 'Victor C-7032 Ultra',
    tagline: 'Stringing Machine 3',
    image: '/images/7032_Ultra.jpeg',
  },
  {
    id: 4,
    name: 'Victor WBS-10',
    tagline: 'Swing Weight Machine',
    image: '/images/WBS-10.jpeg',
  },
  {
    id: 5,
    name: 'ERT 300',
    tagline: 'Tension Controller',
    image: '/images/ERT300.jpeg',
  },
  {
    id: 6,
    name: 'Grommet Flaring',
    tagline: '',
    image: '/images/grommet_flaring.jpeg',
  },
  {
    id: 6,
    name: 'Grommet Rotator',
    tagline: '',
    image: '/images/grommet_rotator.jpeg',
  },
  {
    id: 8,
    name: 'Heat Gun',
    tagline: 'For Strink Wrap Wooden Handler',
    image: '/images/heat_gun.jpeg',
  },
];
